<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-for="item in list" :key="item.customerLogId" class="lineRect">
      <div class="icon" @click="onSelect(item)">
        <img :src="item.headIcon?item.headIcon:'/img/defaultHead.jpg'">
      </div>
      <div class="datas" @click="onSelect(item)">
        <div class="localname">{{ item.loaclName }}</div>
        <div class="name">{{ item.lastName }} {{ item.firstName }}</div>
        <div class="info">地址:{{ item.country }} {{ item.zipString }}</div>
      </div>
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="warning" size="large" :color="GetColorMain()" style="width:100%" @click="onAdd">新增顾客信息</van-button>
    </div>
    <updateCustomerInfo v-model="customerOrderId" show-type="manage" @reload="onInit" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import updateCustomerInfo from '@/components/updateCustomerInfo'
export default {
  components: {
    [Button.name]: Button,
    TopBar,
    updateCustomerInfo
  },
  data() {
    return {
      titleTop: '',
      title: '顾客信息',
      backurl: '/my/index',
      list: [],
      customerOrderId: undefined
    }
  },

  created() {
    this.onInit(() => {
      this.titleTop = GetSysTitle()
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onInit(callback) {
      request({
        url: '/storeHelper/getUserCustomerInfoList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
        if (callback) {
          callback()
        }
      })
    },
    onAdd() {
      this.customerOrderId = 0
    },
    onSelect(item) {
      this.customerOrderId = item.customerLogId
    }
  }
}
</script>
<style scoped>
.lineRect{
    padding: 0.5em;
    background-color: #fff;
    border-radius: 0.4em;
    position: relative;
    height: 5em;
    margin: 0.5em 1em;
}
.lineRect .icon{
    position: absolute;
    height: 5em;
    width: 3.846em;
}
.lineRect .icon img{
    height: 100%;
    width: 100%;
}
.lineRect .datas{
    position: absolute;
    left: 5em;
    top:0.5em;
    bottom: 0.5em;
    right: 0.5em;
}
.lineRect .datas .localname{

}
.lineRect .datas .name{
    color: #999;
    font-size: 0.8em;
    margin: 0.3em 0;
}
.lineRect .datas .info{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 0.9em;
}
.emptyRect{
  height: 3em;
}
.downButton{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
